<template>
  <v-navigation-drawer
    ref="drawer"
    app
    right
    clipped
    width="300"
    :mini-variant.sync="mini"
    mini-variant-width="35"
    permanent
  >
    <template v-if="mini">
      <div class="fill-height centered-div">
        <v-icon @click="mini = false">mdi-chevron-left</v-icon>
      </div>
    </template>

    <template v-else>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title
            class="text-h6"
            style="display: flex; justify-content: space-between"
          >
            <p class="mb-0">Panel de control</p>
            <v-icon @click="cerrarPropiedades">mdi-close</v-icon>
          </v-list-item-title>

          <!-- Tabs -->
          <v-tabs
            v-model="activeTab"
            style="width: 100%"
          >
            <v-tab>Propiedades</v-tab>
            <v-tab>Acciones</v-tab>
          </v-tabs>

          <v-tabs-items
            v-model="activeTab"
            style="width: 100%"
          >
            <!-- Tab de Propiedades -->
            <v-tab-item>
              <v-container>
                <v-row>
                  <v-checkbox
                    v-model="isActive"
                    label="Activo"
                  />
                </v-row>
                <v-expansion-panels class="mb-2">
                  <v-expansion-panel>
                    <v-expansion-panel-header>Posición</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row> X: <v-text-field v-model.number="selectedItem?.customized.left" /></v-row>
                      <v-row>
                        Y: <v-text-field v-model.number="selectedItem?.customized.top" />
                      </v-row>
                      <v-row>
                        H: <v-text-field v-model.number="selectedItem?.customized.height" />
                      </v-row>
                      <v-row>
                        W: <v-text-field v-model.number="selectedItem?.customized.width" />
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
                <v-row>
                  <v-text-field prefix="Z-index:" v-model="zIndex" type="number" />
                </v-row>
                <slot v-if="selectedItem"></slot>
                <page-properties v-else></page-properties>
              </v-container>
            </v-tab-item>

            <!-- Tab de Acciones -->
            <v-tab-item>
              <v-container>
                <v-row>
                  <p class="mb-0">Acciones</p>
                </v-row>
                <!-- Aquí van tus botones de acción -->
                <v-row>
                  <v-btn block color="primary" @click="copySelectedElement()">Copiar</v-btn>
                </v-row>
                <v-row>
                  <v-btn block color="secondary" @click="pasteSelectedElement()">Pegar</v-btn>
                </v-row>
                <!-- Puedes agregar más botones según sea necesario -->
              </v-container>
            </v-tab-item>
          </v-tabs-items>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapActions } from "vuex";
import PageProperties from "../pages/PageProperties.vue";

export default {
  name: "PropertyWindow",

  components: {
    PageProperties,
  },

  data() {
    return {
      navigation: {
        borderSize: 3,
        width: 300,
      },
      mini: true,
      zIndex: 1,
      isActive: true, // Estado para el checkbox de activo
      activeTab: 0, // Para controlar qué tab está activo
    };
  },

  computed: {
    ...mapState(["selectedItem"]),
  },

  methods: {
    ...mapActions(["deselectItem","copySelectedElement","pasteSelectedElement"]),
    cerrarPropiedades() {
      this.mini = true;
      this.deselectItem();
    },
    setEvents() {
      const minSize = this.navigation.borderSize;
      const el = this.$refs.drawer.$el;
      const drawerBorder = el.querySelector(".v-navigation-drawer__border");
      const vm = this;
      const direction = el.classList.contains("v-navigation-drawer--right") ? "right" : "left";

      function resize(e) {
        document.body.style.cursor = "ew-resize";
        let f = direction === "right" ? document.body.scrollWidth - e.clientX : e.clientX;
        el.style.width = f + "px";
      }

      drawerBorder.addEventListener(
        "mousedown",
        function (e) {
          if (e.offsetX < minSize) {
            el.style.transition = "initial";
            document.addEventListener("mousemove", resize, false);
          }
        },
        false
      );

      document.addEventListener(
        "mouseup",
        function () {
          el.style.transition = "";
          vm.navigation.width = el.style.width;
          document.body.style.cursor = "";
          document.removeEventListener("mousemove", resize, false);
        },
        false
      );
    },
  },

  mounted() {
    this.setEvents();
    this.zIndex = this.selectedItem?.customized.zIndex;
  },

  watch: {
    selectedItem() {
      this.mini = !this.selectedItem;
    },
    zIndex() {
      if (!this.selectedItem) return;

      if (!("zIndex" in this.selectedItem?.customized)) {
        this.$set(this.selectedItem.customized, "zIndex", this.zIndex);
      } else {
        this.selectedItem.customized.zIndex = this.zIndex;
      }
    },
    isActive(newVal) {
      if (!this.selectedItem) return;
      if (!("active" in this.selectedItem?.customized)) {
        this.$set(this.selectedItem.customized, "active", newVal);
      } else {
        this.selectedItem.customized.active = newVal;
      }
    },
  },
};
</script>

<style>
.centered-div {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
</style>